'use strict';

class applicationSettingsParser {

    constructor() {

        //Attributes
        this.restrict = 'A';
        this.require = '?ngModel';
    }

    link($scope, element, attributes, ngModelCtrl) {
        function toViewValue(value) {
            let encoded;
            try {0
                encoded = JSON.stringify(value);
            } catch(e) {
                encoded = '{}';
            }

            return encoded;
        }

        function toObject(viewValue) {
            if(!viewValue) {

                return {};
            }

            let decoded;
            try {
                decoded = JSON.parse(viewValue);
            } catch(e) {
                decoded = {};
            }

            return decoded;
        }

        if(attributes.ngModel) {
            //object -> json
            ngModelCtrl.$formatters.push(toViewValue);

            //json -> object
            ngModelCtrl.$parsers.push(toObject);
        }
    }
}

/*
 * Browsify connection: execute service
 * @Return {Object} A new instance of this directive
 */
module.exports = [() => {

    //Create new instance
    applicationSettingsParser.instance = new applicationSettingsParser();
    return applicationSettingsParser.instance;
}];